export default __webpack_public_path__ + "static/media/quick.7e3a92e1.svg";